const formatArr = [
  // { code: 'DD MM YYYY hh:mm:ss', name: 'DD MM YYYY hh:mm:ss' },
  // { code: 'DD MM YYYY hh:mm', name: 'DD MM YYYY hh:mm' },
  // { code: 'DD MM YYYY', name: 'DD MM YYYY' },
  { code: 'DD.MM.YY', name: 'DD.MM.YY' },
  { code: 'MM.DD.YY', name: 'MM.DD.YY' },
  { code: 'YY.MM.DD', name: 'YY.MM.DD' },
];

export default formatArr;
